import type { ErrorTranslations } from "./utils";

export default {
  reusable_element_not_found: {
    EN: "Reusable element not found",
    RO: "Elementul reutilizabil nu a fost găsit",
  },
  element_required: {
    EN: "An element is missing from the form",
    RO: "Un element lipsește din formular",
  },
  page_form_not_found: {
    EN: "Form not found",
    RO: "Formularul nu a fost găsit",
  },
  already_added_to_institution: {
    EN: "Form is already added to this institution",
    RO: "Formularul este deja adăugat la această instituție",
  },
  not_found: {
    EN: "Form not found",
    RO: "Formularul nu a fost găsit",
  },
  failed_to_add_to_institution: {
    EN: "Failed to add form to institution",
    RO: "Formularul nu a putut fi adăugat la instituție",
  },
  failed_to_create_new: {
    EN: "Failed to create form",
    RO: "Formularul nu a putut fi creat",
  },
  cannot_update_disabled: {
    EN: "Cannot update disabled form",
    RO: "Nu se poate actualiza un formular inactiv",
  },
  section_not_found: {
    EN: "Section not found",
    RO: "Secțiunea nu a fost găsită",
  },
  cannot_update_reusable_section: {
    EN: "Cannot update reusable section",
    RO: "Sectiunea reutilizabila nu se poate actualiza",
  },
  cannot_update_reusable_element: {
    EN: "Cannot update reusable element",
    RO: "Elementul reutilizabil nu se poate actualiza",
  },
  cannot_delete_category: {
    EN: "Cannot delete category. Move or delete all forms from the category first.",
    RO: "Categoria nu se poate șterge. Mutați sau ștergeți întâi toate formularele din categoria respectivă.",
  },
  email_not_found: {
    EN: "Email not found",
    RO: "Emailul nu a fost găsit",
  },
} satisfies ErrorTranslations;
